'use client';

import type { LexicalEditor } from 'lexical';
import { createContext, type JSX, useContext } from 'react';

const Context = createContext<{
  activeEditor: LexicalEditor;
  $updateToolbar: () => void;
  blockType: string;
  setBlockType: (blockType: string) => void;
  showModal: (title: string, showModal: (onClose: () => void) => JSX.Element) => void;
  onImageUpload?: (file: File) => Promise<string>;
}>({
  activeEditor: {} as LexicalEditor,
  $updateToolbar: () => {},
  blockType: 'paragraph',
  setBlockType: () => {},
  showModal: () => {},
  onImageUpload: undefined,
});

export function ToolbarContext({
  activeEditor,
  $updateToolbar,
  blockType,
  setBlockType,
  showModal,
  onImageUpload,
  children,
}: {
  activeEditor: LexicalEditor;
  $updateToolbar: () => void;
  blockType: string;
  setBlockType: (blockType: string) => void;
  showModal: (title: string, showModal: (onClose: () => void) => JSX.Element) => void;
  onImageUpload?: (file: File) => Promise<string>;
  children: React.ReactNode;
}) {
  return (
    <Context.Provider
      value={{
        activeEditor,
        $updateToolbar,
        blockType,
        setBlockType,
        showModal,
        onImageUpload,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export function useToolbarContext() {
  return useContext(Context);
}
